import React from 'react';
import {
  Box,
  Typography,
  makeStyles,
  Theme,
  createStyles,
  Paper,
  Radio,
} from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import mainColors from '../../../themes/main-colors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    optionCard: {
      padding: theme.spacing(2),
      border: `1px solid ${mainColors.lightGray1}`,
      borderRadius: 8,
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      minHeight: 86,
      transition: 'all 0.2s',
      width: '100%',
    },
    selectedCard: {
      border: `2px solid ${mainColors.sparkBlue}`,
      backgroundColor: mainColors.modalBlue,
    },
    iconWrapper: {
      width: 42,
      height: 42,
      borderRadius: '50%',
      backgroundColor: mainColors.lightGray2,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginRight: theme.spacing(2),
      fontSize: 20,
    },
    iconWrapperSelected: {
      backgroundColor: mainColors.lightGray2,
    },
    cardContent: {
      flex: 1,
    },
    cardTitle: {
      fontWeight: 700,
      fontSize: 14,
    },
    cardDescription: {
      color: mainColors.darkGray2,
      fontSize: 12,
      marginTop: 2,
    },
  }),
);

interface EnergyNeedCardProps {
  selected: boolean;
  title: string;
  description: string;
  icon: React.ReactNode;
  onSelect: () => void;
}

const EnergyNeedCard: React.FC<EnergyNeedCardProps> = ({
  selected,
  title,
  description,
  icon,
  onSelect,
}) => {
  const classes = useStyles();

  return (
    <Paper
      elevation={0}
      className={`${classes.optionCard} ${
        selected ? classes.selectedCard : ''
      }`}
      onClick={() => onSelect()}
    >
      <Radio checked={selected} color="primary" />

      <Box
        className={`${classes.iconWrapper} ${
          selected ? classes.iconWrapperSelected : ''
        }`}
      >
        {icon}
      </Box>

      <Box className={classes.cardContent}>
        <Typography className={classes.cardTitle}>{title}</Typography>

        <Typography className={classes.cardDescription}>
          {description}
        </Typography>
      </Box>
    </Paper>
  );
};

export default EnergyNeedCard;
